import { Inject, Injectable, Injector, LOCALE_ID, Optional } from "@angular/core";
import { BefRepository, ResponseInfo } from "@farris/bef";
import { FrameContext, RestfulService, Repository } from '@farris/devkit';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FeatureRepository } from "./feature-repository";
import { Prop } from "./types";
import { BasePathService } from "@farris/rtf";

@Injectable()
export class FeatureDataService {
  constructor(
    private injector: Injector,
    private repository: FeatureRepository,
    @Optional() @Inject(LOCALE_ID) private localeId?: string
  ) {
    this.localeId = this.localeId || 'zh-CHS';
  }
  /**
   * æ ¹æ®ç©æidè·åç©æç¹å¾é¡¹åç¹å¾å¼ï¼å¬å±é»è®¤å¼ï¼
   * @param materialId ç©æid
   */
  public getFeaturesByMaterialId(materialId: string): Observable<Prop.IReturnValue> {
    return this.repository.getFeaturesByMaterialId(materialId).pipe(
      map((response: ResponseInfo) => {
        if (!response || !response.returnValue) {
          return null;
        }
        const returnValue = JSON.parse(response.returnValue);
        const result: Prop.IReturnValue = { propset: [], props: [] };
        const propsets = returnValue.propset || null;
        const props = returnValue.props || null;
        if (propsets && Array.isArray(propsets)) {
          propsets.map((propset: Prop.IPropSet) => {
            propset.name = this.translateName(propset);
            return propset;
          });
          result.propset = propsets;
        }
        if (props && Array.isArray(props) && props.length > 0) {
          props.map((prop: Prop.IProp) => {
            // å¤çå¤è¯­
            prop.name = this.translateName(prop);
            // å¤çæä¸¾
            if (prop.inputtype === Prop.InputType.enum && prop.enuminfo) {
              prop.data = JSON.parse(prop.enuminfo);
            }
            // å¤çå¿å¡«ååªè¯»
            prop.isreadonly = prop.isreadonly === '1' ? true : false;
            prop.isrequired = prop.isrequired === '1' ? true : false;
            return prop;
          });
          result.props = props;
        }
        return result;
      })
    );
  }
  /**
   * æ ¹æ®ç©æidåç©æç¹å¾ä¿å­åçhashè·åè¯¥ç©æå·²ç»å­å¨çç¹å¾é¡¹å¼
   * @param materialId ç©æId
   * @param configID å¯¹åºè¯¥ç©æçç¹å¾é¡¹hash
   * @returns
   */
  public getConfigedValueByFeatureId(materialId: string, configID: string, configType: string = 'Materials'): Observable<any> {
    return this.repository.getConfigedValueByFeatureId(materialId, configID, configType).pipe(map((result: any) => {
      return JSON.parse(result);
    }));
  }
  /**
   * ä¿å­ç©æç¹å¾é¡¹
   * @param materialId ç©æid
   * @param charactValue ç¹å¾å¼
   * @param configType éç½®ç±»å
   * @returns
   */
  public applyFeatures(materialId: string, charactValue: any, configType: string = 'Materials') {
    return this.repository.applyFeatures(materialId, charactValue, configType).pipe(map((config: any) => {
      return JSON.parse(config);
    }));
  }
  /**
   * è·åå¸®å©ä¿¡æ¯
   * @param helpid å¸®å©id
   * @param filter è¿æ»¤æ¡ä»¶
   * @param params åæ°
   * @returns
   */
  public getHelpInfo(helpid: string, filter: string, params: any): Observable<any> {
    const url = BasePathService.convertPath('/api/scm/scmfnd/v1.0/scmcommoncmpservice/service/gethelpdata');
    const httpParams: any = {};
    if (params) {
      if (params.pageIndex) {
        httpParams['pageIndex'] = JSON.stringify(params.pageIndex - 0);
      }
      if (params.pageSize) {
        httpParams['pageSize'] = JSON.stringify(params.pageSize - 0);
      }
      if (params.condition) {
        httpParams['condition'] = JSON.stringify(params.condition);
      }
      if (params.searchValue) {
        httpParams['search'] = params.searchValue;
      }
    }
    const body = {
      helpID: helpid,
      queryParam: JSON.stringify(httpParams),
      filterStr: filter
    };
    const befRepository: BefRepository<any> = null;//this.repository as BefRepository<any>;
    const options = {
      body
    };
    return befRepository.proxy.request(url, 'put', null, options).pipe(
      map((result: any) => JSON.parse(result))
    );
  }
  /**
   * å½éåç¹å¾é¡¹æç¹å¾éåç§°
   * @param object ç¹å¾éæç¹å¾é¡¹å¯¹è±¡
   * @returns
   */
  private translateName(object: Prop.IPropSet | Prop.IProp): string {
    if (!object) {
      return null;
    }
    let name = null;
    switch (this.localeId) {
      case 'en': {
        name = object['name_en'];
      } break;
      case 'zh-CHS': {
        name = object['name_chs'];
      } break;
      case 'zh-CHT': {
        name = object['name_cht'];
      } break;
      default: name = object['name_chs'];
    }
    return name;
  }
}
